var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MatFieldComponent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { HubPlace } from '../../../../models/hub/hub.place';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { EventTimeService } from '../../../../services/event.time.service';
import { ImageService } from '../../../../services/image.service';
import { AllFrontendSettingsStore, VisitorTripNotifyAddOrRemoveItemStore, } from '../../../../stores/visitor.calendar.store';
import { VisitorTripSideBarComponent } from '../trip.side.bar/visitor.trip.side.bar.component';
import { VisitorTripComponent } from '../visitor.trip.component';
import { StyleModel } from '../../../../commands/hub/style.command';
import { EditorChoiceStore } from '../../../../stores/hub.calendar.store';
var VisitorTripPlaceCardComponent = /** @class */ (function (_super) {
    __extends(VisitorTripPlaceCardComponent, _super);
    function VisitorTripPlaceCardComponent(router, formBuilder, imageService, parent, allFrontendSettingsStore, notifyAddOrRemoveItemStore, visitorTripComponent, editorChoiceStore, activatedRoute) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.formBuilder = formBuilder;
        _this.imageService = imageService;
        _this.parent = parent;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.notifyAddOrRemoveItemStore = notifyAddOrRemoveItemStore;
        _this.visitorTripComponent = visitorTripComponent;
        _this.editorChoiceStore = editorChoiceStore;
        _this.activatedRoute = activatedRoute;
        _this.itemType = 'place';
        _this.featuresToggle = new HubVisitorFeatureToggle();
        _this.iconColor = null;
        _this.icon = null;
        _this.addTo = new EventEmitter();
        _this.removeFrom = new EventEmitter();
        _this.locateOnMap = new EventEmitter();
        _this.showDetails = new EventEmitter();
        _this.isInAnyTrip = false;
        _this.isMultiDateEvent = false;
        _this.isAddingSuccess = [];
        _this.inTripStatus = [];
        _this.icons = {
            Accommodations: { icon: 'hotel', color: '#f70096' },
            'Arts & Culture': { icon: 'camera', color: '#9bd53e' },
            'Dining & Nightlife': { icon: 'restaurant', color: '#ec8f07' },
            Activities: { icon: 'local_activity', color: '#8808ec' },
            Shopping: { icon: 'local_grocery_store', color: '#0783eb' },
            'Outdoors & Fitness': { icon: 'terrain', color: '#0d8804' },
            Entertainment: { icon: 'mood', color: '#e5ce02' },
            Transportation: { icon: 'flight_takeoff', color: '#50212e' },
            Other: { icon: 'public', color: '#3d3c3c' },
        };
        _this.style = new StyleModel();
        _this.editorChoiceText = "EDITOR'S CHOICE";
        return _this;
    }
    VisitorTripPlaceCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.icon = this.icons[this.item.mapIcon] && this.icons[this.item.mapIcon].icon;
        this.iconColor = this.icons[this.item.mapIcon] && this.icons[this.item.mapIcon].color;
        this.notifyAddOrRemoveItemStore.notifyCommand.takeUntil(this.isDestroyed).subscribe(function (item) {
            _this.checkIsInAnyTrip();
        });
        this.allFrontendSettingsStore.allFrontendSettingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            if (command.style) {
                _this.style = command.style;
            }
        });
        this.editorChoiceTextHandler();
    };
    VisitorTripPlaceCardComponent.prototype.editorChoiceTextHandler = function () {
        var _this = this;
        this.editorChoiceStore.infoCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (editorChoice) {
            if (!!_this.item['startTime']) {
                _this.editorChoiceText = editorChoice.editorChoiceForEvent;
            }
            else {
                _this.editorChoiceText = editorChoice.editorChoiceForPlace;
            }
        });
    };
    VisitorTripPlaceCardComponent.prototype.checkIsInAnyTrip = function () {
        var _this = this;
        this.parent.loadTripsInLocalStorage();
        if (!this.parent.trips || !this.parent.trips.length) {
            return false;
        }
        this.isInAnyTrip = false;
        this.parent.trips.forEach(function (trip) {
            if (trip.attractions.any(function (x) { return x.item.id === _this.item.id; })) {
                _this.isInAnyTrip = true;
            }
        });
    };
    VisitorTripPlaceCardComponent.prototype.showOnMap = function ($event) {
        if ($event && $event.stopPropagation) {
            $event.stopPropagation();
        }
        this.locateOnMap.emit(this.item);
    };
    VisitorTripPlaceCardComponent.prototype.viewDetails = function ($event) {
        if ($event && $event.stopPropagation) {
            $event.stopPropagation();
        }
        this.showDetails.emit(this.item);
    };
    VisitorTripPlaceCardComponent.prototype.processEventTime = function (event) {
        if (event.startTimeText) {
            if (!this.isMultiDateEvent) {
                this.detailDate = EventTimeService.getDateFromTimeText(event.startTimeText);
                this.detailTime = EventTimeService.getTimeFromTimeText(event.startTimeText, event.timezone);
            }
            else {
                this.detailDate =
                    EventTimeService.getDateFromTimeText(event.startTimeText) +
                        ' - ' +
                        EventTimeService.getDateFromTimeText(event.endTimeText);
            }
        }
        else {
            if (!this.isMultiDateEvent) {
                this.detailDate = EventTimeService.getDateFromTime(event.startTime);
                this.detailTime = EventTimeService.getTimeFromTime(event.startTime);
            }
            else {
                this.detailDate =
                    EventTimeService.getDateFromTime(event.startTime) +
                        ' - ' +
                        EventTimeService.getDateFromTime(event.startTime);
            }
        }
    };
    return VisitorTripPlaceCardComponent;
}(BaseComponent));
export { VisitorTripPlaceCardComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/trip/trip.place.card/visitor.trip.place.card.component.ts.pre-build-optimizer.js